import { atomWithStorage } from "jotai/utils";

/** When true the internal left nav is collapsed to icon-width (64px). */
export const leftNavCollapsedAtom = atomWithStorage<boolean>("adora-internal:left-nav-collapsed", false);
